import { render, staticRenderFns } from "./botonUpdate.vue?vue&type=template&id=5d9eada1"
import script from "./botonUpdate.vue?vue&type=script&lang=js"
export * from "./botonUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports